var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4"},[_c('span',{staticClass:"main-title"},[_vm._v("RIDER SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Extra credit zone report")]),_c('download-excel',{staticStyle:{"position":"absolute","top":"0px","right":"40px"},attrs:{"data":_vm.export_extra_credit_zone_format,"fields":{
            'No': 'No',
            'Order code' : 'order_code',
            'Date' :  'date' ,
            'Rider':  'rider',
            'Remark':  'remark',
            'Point' :  'point',
            'Note' : 'note' 
          },"name":'ExtraCreditZoneReport_'+_vm.search_config.datetime_start+'_to_'+_vm.search_config.datetime_end+'.xls'}},[_c('v-btn',{staticClass:"icon-print",attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls\n      ")],1)],1),_c('download-excel',{staticStyle:{"position":"absolute","top":"0px","right":"150px"},attrs:{"type":"csv","data":_vm.export_extra_credit_zone_format,"fields":{
            'No': 'No',
            'Order code' : 'order_code',
            'Date' :  'date' ,
            'Rider':  'rider',
            'Remark':  'remark',
            'Point' :  'point',
            'Note' : 'note' 
          },"name":'ExtraCreditZoneReport_'+_vm.search_config.datetime_start+'_to_'+_vm.search_config.datetime_end+'.csv'}},[_c('v-btn',{staticClass:"icon-print",attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv\n      ")],1)],1)],1),_c('SearchRiderName'),_c('ExtraCreditZoneReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }